import {
  Button,
  Page,
  SkeletonView,
  Text,
} from "@towersystems/roam-common-native";
import {
  useParkSaleSyncronously,
  useSaleControllerProvider,
  useSwitchSale,
} from "../../utils/sale-controller";
import { useActionBackOrClose } from "../../utils/use-action-back-or-close";
import QRCode from "react-qr-code";
import React from "react";
import { useMutationSaleTransferString } from "../../../sales/utils";
import { Spacings, View } from "react-native-ui-lib";
import { ValidateActiveSale } from "../../components/ValidateActiveSale";

export const TransferSaleRetailerScreen = ({ navigation }: any) => {
  const [loading, setLoading] = React.useState(true);
  const parkSale = useParkSaleSyncronously();

  const { sale } = useSaleControllerProvider();
  const [transferString, setTransferString] = React.useState<
    string | undefined
  >(undefined);

  useActionBackOrClose(navigation);

  const [error, setError] = React.useState<string | undefined>(undefined);
  const { mutation } = useMutationSaleTransferString();

  React.useEffect(() => {
    /**
     * The sale must be parked before it can be transferred in order to
     * ensure that the sale is up to date with the latest changes on the
     * server.
     */

    if (sale) {
      parkSale(undefined, false)
        .then(async (result) => {
          setTransferString(`ROAM_TRANSFER:${result.id}`);
        })
        .catch((err) => console.log(err))
        .finally(() => setLoading(false));
    }
  }, []);

  React.useEffect(() => {
    if (!sale) {
      navigation.getParent().pop();
      return;
    }
  }, [sale]);

  React.useEffect(() => {
    navigation.setOptions({
      headerTitle: () =>
        !loading ? (
          <Text variant="heading">Transfer Sale to Retailer</Text>
        ) : (
          <SkeletonView textVariant="heading" />
        ),
    });
  }, [loading, navigation]);

  if (loading) {
    return (
      <Page>
        <View
          flex
          style={{
            width: "100%",
            padding: Spacings.s5,
            height: "100%",
          }}
          center
        >
          <View style={{ maxWidth: 400, width: "100%", aspectRatio: 1 }}>
            <SkeletonView style={{ width: "100%" }} height={400} />
          </View>
        </View>
      </Page>
    );
  }

  const handleOnParkSale = async () => {
    try {
      await parkSale();
      navigation.getParent().pop();
    } catch (e) {
      console.log(e);
    }
  };

  const qrcMarkup = transferString && (
    <View
      flex
      style={{
        width: "100%",
        padding: Spacings.s5,
      }}
      center
    >
      <View style={{ maxWidth: 400, width: "100%" }}>
        <QRCode
          style={{ height: "auto", maxWidth: "100%", width: "100%" }}
          size={256}
          value={transferString}
        />
      </View>
    </View>
  );

  const footerMarkup = (
    <Button label={"Park Sale"} isAction onPress={handleOnParkSale}></Button>
  );

  return (
    <Page footer={footerMarkup}>
      <ValidateActiveSale interval={1000} />
      {qrcMarkup}
    </Page>
  );
};
